/* eslint-disable react/prop-types */
import React from 'react';

import { StyledItemValidation } from './styles';
import iconSuccessGreen from '../../../assets/img/icon-success.svg';
import iconError from '../../../assets/img/icon-error.svg'

const format = {
  success: {
    icon: iconSuccessGreen,
    color: '#0E891A',
  },
  disabled: {
    icon: 'none',
    color: '#6D6D6D'
  },
  error: {
    icon: iconError,
    color: '#CC284E',
  }
}

const ItemValidation = (props) => {
  const { children, type, fontSize = '14', className = '' } = props; // COMMENT: type: error, primary, success, info, warning, disabled

  return (
    <StyledItemValidation color={format[type]?.color} fontSize={fontSize} className={className}>
      {format[type]?.icon !== 'none' && <img src={format[type]?.icon} width={fontSize} alt="" />}
      {children}
    </StyledItemValidation>
  );
}

export default ItemValidation;
